import Vue from 'vue'
import Router from 'vue-router'
import basicMap from '@/components/basic-map'
import basicList from '@/components/basic-list'
import person from '@/components/person'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'basicMap',
      component: basicMap
    },
    {
      path: '/basic-list',
      name: 'basicList',
      component: basicList
    },
    {
      path: '/person',
      name: 'person',
      component: person
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js